<template>
    <!-- <div class="list-content pa15">
        <div class="koin-title">KOIN지급</div>
        <div class="koin-text-box">옵션</div>
        <div class="koin-input-box">
            <el-select v-model="paymentType" placeholder="옵션">
                <el-option
                  v-for="item in selectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
        </div>
        <div class="koin-text-box">koin</div>
        <div class="koin-input-box">
            <el-input class="koin-input search-input" type="number" v-model="koin" placeholder="지급코인 입력"
                @input="parentChange('koin', koin)"></el-input>
            <div class="input_error" v-html="validation.firstError('koin')"></div>
        </div>
        <div class="koin-text-box">내용</div>
        <div class="koin-input-box">

            <el-input class="koin-input search-input" v-model="reason" type="text" placeholder="지급/ 차감 내용을 입력해 주세요" maxLength="100"
                      @input="parentChange('reason', reason)"></el-input>
            <div class="input_error" v-html="validation.firstError('reason')"></div>
        </div>
        <div>
            <button>추가</button>
        </div>
    </div> -->
    <div class="table_wrap koin-wrap">
        <div class="koin-title pb24 pt24">KOIN지급</div>
        <div class="c_table_wrap">
            <div class="filter-select-div mb11 ml24">
                <span class="filter-select-span mr24">옵션</span>
                <el-select v-model="paymentType" class="select mr5" @change="parentChange('type', paymentType)">
                    <el-option
                  v-for="item in selectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
                </el-select>
                <span class="filter-select-span ml24 mr24">KOIN</span>
                <div class="koin-input koin-input-small   table_s_input  mr5">
                    <el-input class="" type="number" v-model="koin" placeholder="지급/ 차감코인 입력"
                        @input="parentChange('koin', koin)"></el-input>
                    <!-- <div class="input_error" v-html="validation.firstError('koin')"></div> -->
                </div>
                <span class="filter-select-span ml24 mr24">내용</span>
                <div class="koin-input koin-input-large table_s_input mr5">
                    <el-input class="" v-model="reason" type="text" placeholder="지급/ 차감 내용을 입력해 주세요" maxLength="100"
                      @input="parentChange('reason', reason)"></el-input>
                    <!-- <div class="input_error" v-html="validation.firstError('reason')"></div> -->
                </div>
                <el-button class="koin-button" @click="save()"  :disabled="checkAll">
                    추가
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import koinValidator from "@/mixins/validators/koinValidator";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

export default {
    name: "KoinDefaultLayout",
    mixins: [koinValidator],
    inject: ['koinSetData'],
    components: {},
    props: {
        memberKey: ''
    },
    data() {
        return {
            item: '',
            koin: '',
            reason: '',
            selectOptions:[
                {
                    label:'지급 (+)',
                    value:'ADMINPLUS',
                },{
                    label:'차감 (-)',
                    value:'ADMINMINUS',
                }
            ],
            paymentType:'ADMINPLUS',
            checkAll:true,
        }
    },
    beforeRouterEnter() {
    },
    created() {

    },
    mounted() {
        this.parentChange('type', this.paymentType);
        EventBus.$on('KoinDefaultLayoutValidator', this.checkValidator)
    },
    beforeDestroy() {
        EventBus.$off('KoinDefaultLayoutValidator', this.checkValidator)
    },
    destroyed() {
    },
    computed: {},
    methods: {
        parentChange(key, value) {
            this.koinSetData(key, value)
            if(!util.isEmpty(this.paymentType) &&!util.isEmpty(this.koin) && !util.isEmpty(this.reason)){
                this.checkAll = false;
            }else this.checkAll = true

        },
        checkValidator(dataArr) {
            this.$validate(dataArr)
        },
        save(){
            EventBus.$emit('paymentsKoin')
            setTimeout(() => {
            this.koin = '';
            this.koinSetData('koin',this.koin);
            this.reason = '';
            this.koinSetData('reason',this.reason);
            this.checkAll = true;
            }, 100);
        }
    },
    watch: {},
}
</script>

<style scoped>

</style>
